// Parity P5 — client hooks for /playbooks (public).
import { useQuery } from '@tanstack/react-query'
import { api } from '#/lib/api'

export interface PlaybookDto {
  id: string
  version: number
  name: { en: string; id: string }
  desc: { en: string; id: string }
  idea?: { en: string; id: string }
  kitId: string
  stack: string
  tags: string[]
  examples: { en: string[]; id: string[] }
  rules: { kind: 'always' | 'never' | 'ask'; templateId: string; text: { en: string; id: string } }[]
  source: 'bystep' | 'community'
  repo?: string
}
export interface CommunityStatusDto {
  ok: boolean
  count: number
  error?: string
  fetchedAt: string | null
}

export const usePlaybooks = () =>
  useQuery({
    queryKey: ['public-playbooks'],
    queryFn: () => api<{ playbooks: PlaybookDto[]; community: CommunityStatusDto }>('/api/public/playbooks'),
    staleTime: 5 * 60_000,
  })
